import React, { useEffect, useState } from 'react';
import { usePhoneInput } from '../../../../../Hooks';
import PhoneInput from 'react-phone-input-2';
import userEvent from '@testing-library/user-event';
import axios from 'axios';
import useAxios from '../../../../../Hooks/use-axios';

const restrictedChars = /[`!£#$%&()*+₹;<|=>^~?]/g;

function Address({
    deal,
    formData,
    setFormData,
    name,
    nameChangedHandler,
    nameBlurHandler,
    nameHasError,
    nameIsValid,
    Pin,
    PinChangedHandler,
    PinHasError,
    PinBlurHandler,
    PinIsValid,
    phoneNumber,
    phoneChangedHandler,
    phoneBlurHandler,
    phoneHasError,
    phoneNumberIsValid,
    mobileNumberIsValid,
    mobile,
    setMobile,
    mobileHasError,
    onChange,
    validator,
    setIsTouched,
    setInputFocused
}) {
    const { isLoading: loadingSimilarDeals, sendExternalRequest: fetchPin } =
        useAxios();
    const [disableForm, setDisableForm] = useState(false);
    const handleChange = (e) => {
        const { name, value } = e.target;
        const UpdatedValue =
            name === 'address' ? value.replace(restrictedChars, ' ') : value;

        setFormData((prevState) => ({
            ...prevState,
            [name]: UpdatedValue
        }));
        console.log('Form Data:', formData);
    };

    useEffect(() => {
        //Fetch address details based on pin code
        if (/^\d{6}$/.test(Pin)) {
            setDisableForm(false);
            const url = `https://api.postalpincode.in/pincode/${Pin}`;
            const method = 'GET';
            fetchPin(
                {
                    isEncryptedResponse: false,
                    url,
                    method
                },
                (res) => {
                    if (
                        res.status === 200 &&
                        res?.data[0]?.PostOffice?.length > 0
                    ) {
                        const postOffice = res?.data[0]?.PostOffice[0];
                        setFormData((prevState) => ({
                            ...prevState,
                            city: postOffice.District,
                            state: postOffice.State
                        }));
                        setDisableForm(true);
                    } else {
                        setDisableForm(false);
                        setFormData((prevState) => ({
                            ...prevState,
                            city: '',
                            state: ''
                        }));
                    }
                }
            );
        }
    }, [Pin]);

    return (
        <div className=" flex flex-col justify-center">
            <div className="">
                <h3 className="font-medium text-primary">
                    Ready to Redeem your product?
                </h3>
                <h1 className="font-bold text-lg">Contact Details</h1>
                <h2 className="  text-sm">{`Enter the details of the person receiving the order.`}</h2>
            </div>

            <div className="mt-4">
                <form className="pt-2 pb-5">
                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700">
                            Name
                            <span className="text-red-400"> *</span>
                        </label>

                        <input
                            type="text"
                            className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            onChange={nameChangedHandler}
                            onBlur={nameBlurHandler}
                            value={name}
                            autoComplete="off"
                        />
                        {nameHasError && (
                            <p className="mt-1 text-left text-red-400 text-sm">
                                {`Please enter a valid Name`}
                            </p>
                        )}
                    </div>

                    <div className={` w-full flex flex-col mx-auto relative`}>
                        <label className="block mb-1 text-sm font-medium text-gray-700 ">
                            Phone number
                            <span className="text-red-400"> *</span>
                        </label>
                        <PhoneInput
                            // disabled={isOtpSent}
                            country="in"
                            countryCodeEditable={false}
                            containerClass={
                                'peer py-3 border border-gray-300 focus:outline-none rounded-md focus:border-gray-500 focus:shadow-sm w-full  h-11 placeholder-transparent'
                            }
                            containerStyle={{
                                width: '100%',
                                border: '2px solid grey !important',
                                outline: 'none'
                            }}
                            buttonStyle={{
                                backgroundColor: 'white',
                                border: 'none'
                            }}
                            inputStyle={{
                                width: '100%',
                                height: 'auto',
                                border: 'none',
                                outline: 'none',
                                paddingLeft: '44px',
                                fontSize: '16px'
                            }}
                            isValid={validator}
                            onChange={onChange}
                            value={mobile}
                            placeholder="Phone"
                            enableSearch
                            onBlur={() => {
                                setIsTouched(true);
                                setInputFocused(false);
                            }}
                            onFocus={() => setInputFocused(true)}
                            inputClass="border border-gray-300"
                        />
                        {mobileHasError && (
                            <p
                                className={` text-left text-sm mt-1 text-red-400`}
                            >
                                Please enter a valid number
                            </p>
                        )}
                    </div>
                    <div className="mb-6 mt-6">
                        <label className="block text-sm font-medium text-gray-700">
                            Alternate Mobile Number
                            {/* <span className="text-red-400"> *</span> */}
                        </label>
                        <input
                            type="text"
                            onChange={phoneChangedHandler}
                            onBlur={phoneBlurHandler}
                            value={phoneNumber}
                            autoComplete="off"
                            className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm  "
                        />
                        {phoneHasError && (
                            <div className="">
                                <p className="text-left text-sm  text-red-400 mt-1">
                                    Please enter a valid phone Number
                                </p>
                            </div>
                        )}
                    </div>

                    <h1 className="font-bold text-lg mb-4">Delivery Address</h1>

                    <div className="mb-6">
                        <label className="block text-sm font-medium text-gray-700">
                            Address (House No, Building, Street, Area)
                            <span className="text-red-400"> *</span>
                        </label>

                        <textarea
                            type="text"
                            name="address"
                            className="mt-1 block  w-full text-grey-900 h-16 lg:h-12 xl:h-16 rounded-md p-2 border-[#BFBFBF] focus:border-[#BFBFBF] outline-none border-[1px]"
                            value={formData.address}
                            onChange={handleChange}
                        />
                    </div>

                    <div className="flex mb-6">
                        <div className="w-1/2 pr-2">
                            <label className="block text-sm font-medium text-gray-700">
                                Locality / Town
                                <span className="text-red-400"> *</span>
                            </label>
                            <input
                                type="text"
                                name="locality"
                                value={formData.locality}
                                onChange={handleChange}
                                className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </div>
                        <div className="w-1/2 pl-2">
                            <label className="block text-sm font-medium text-gray-700">
                                Pincode
                                <span className="text-red-400"> *</span>
                            </label>

                            <input
                                className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                type="text"
                                value={Pin}
                                onChange={(e) => {
                                    PinChangedHandler(e);
                                }}
                                maxLength={6}
                                onBlur={PinBlurHandler}
                            />
                            {PinHasError && (
                                <p className="text-left text-red-400 text-sm mt-1">
                                    {`Please enter a valid pin`}
                                </p>
                            )}
                        </div>
                    </div>

                    <div className="flex mb-6">
                        <div className="w-1/2 pr-2">
                            <label className="block text-sm font-medium text-gray-700">
                                City / District
                                <span className="text-red-400"> *</span>
                            </label>
                            <input
                                type="text"
                                name="city"
                                value={formData.city}
                                disabled={disableForm}
                                onChange={handleChange}
                                className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </div>
                        <div className="w-1/2 pl-2">
                            <label className="block text-sm font-medium text-gray-700">
                                State
                                <span className="text-red-400"> *</span>
                            </label>
                            <input
                                type="text"
                                name="state"
                                value={formData.state}
                                disabled={disableForm}
                                onChange={handleChange}
                                className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Address;
